import React from "react";
import {
    Box,
    Flex,
    ScaleFade,
    useDisclosure,
} from "@chakra-ui/react";
import { BsGearFill } from "react-icons/bs";
import {
    FiHome,
    FiBriefcase,
    FiCalendar,
} from 'react-icons/fi';
import {
    Route,
    Link,
    useParams,
} from "react-router-dom";
import JobBoard from "../../Admin/AdminJob/AdminJobBoard/AdminJobBoard";
import AddJob from "../../Admin/AdminJob/JobForm/AddJob/AddJob";
import CalendarComponent from "../../Shared/CalendarComponent/CalendarComponent";
import DashboardWrapper from "../../Layouts/MainWrapper";

export default function UserMain() {
    const sidebar = useDisclosure();
    const integrations = useDisclosure();

    const { tenantID } = useParams();

    const SideBarComponent = (NavItem) => {
        return (
            <Flex
                direction="column"
                as="nav"
                fontSize="sm"
                color="gray.800"
                aria-label="Main Navigation"
                p="4"
            >
                {/* <NavItem icon={ArrowBackIcon} display={{ md: "none" }} onClick={sidebar.onClose}>Back</NavItem> */}
                <Link to={`/${tenantID}/user`} onClick={sidebar.onClose}>
                    <NavItem
                        linkto={`/${tenantID}/user`}
                        key="Home" icon={FiHome}>
                        Home
                    </NavItem>
                </Link>

                <Link to={`/${tenantID}/user/jobs/all`} onClick={sidebar.onClose}>
                    <NavItem
                        linkto={`/${tenantID}/user/jobs`}
                        icon={FiBriefcase}>Jobs </NavItem>
                </Link>

                <Link to={`/${tenantID}/user/calendar`} onClick={sidebar.onClose}>
                    <NavItem
                        linkto={`/${tenantID}/user/calendar`}
                        icon={FiCalendar}>Calendar</NavItem>
                </Link>

                <NavItem
                    fontWeight="sm"
                    icon={BsGearFill}>Settings</NavItem>

            </Flex>

        )
    }

    const SwitchComponent = () => {
        return (
            <>
                <Route path={`/:tenantID/user/job/add`}>
                    <AddJob />
                </Route>

                <Route path={`/:tenantID/user/jobs/:JobID`} component={JobBoard} />


                <Route path={`/:tenantID/user/calendar`}>
                    <ScaleFade key="Calendar" initialScale={0.1} in>
                        <Box
                            background="white"
                            borderWidth="2px"
                            borderStyle="solid"
                            boxShadow={'md'}
                            rounded="md"
                            h="80vh"
                            p="2">
                            <CalendarComponent />
                        </Box>
                    </ScaleFade>
                </Route>

                <Route exact path={`/:tenantID/user`}>
                    <Box borderWidth="4px" borderStyle="dashed" rounded="md" h="96">
                        dashboard
                    </Box>
                </Route>


                {/* <Route path={`/:tenantID/user/jobs/:id`}>
                <Box borderWidth="4px" borderStyle="dashed" rounded="md" h="96">
                    <JobCard />
                </Box>
            </Route>
            <Route path={`/:tenantID/user/jobs">
                <JobBoard />
            </Route> */}
            </>
        )
    }

    // pass switch component and sidebar into DashboardWrapper, DashboardWrapper wraps the navigation for us so we can keep it dry
    return <DashboardWrapper

        sidebarcomponent={SideBarComponent}
        switchcomponent={SwitchComponent}
    />

}
